import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/ecommerce-localization/page.tsx");
